module.exports = __webpack_public_path__ + "img/tintuc23.1c00e84f.png";